import { createAsyncThunk } from "@reduxjs/toolkit";
import { CachePolicies } from "use-http";

import { JANZU_URL } from "config/config";
import { HubWithStatus } from "models/hub";
import { isHubRestarting } from "utils/hubs";

interface GetHubArgs {
  hubId: string;
}

export const getHubs = createAsyncThunk("hubs/getHubs", async () => {
  const HUBS_URL = `${JANZU_URL}reef-api/hubs`;
  const response = await fetch(HUBS_URL, {
    cache: CachePolicies.NO_CACHE,
  });
  if (response.ok) {
    const data = await response.json();

    return data.map((hub: HubWithStatus) => ({
      ...hub,
      isLoading: true,
      isRestarting: isHubRestarting(hub.id),
      error: false,
    }));
  }
  throw new Error("Failed to fetch Vision Cores");
});

export const getHubAuthCode = createAsyncThunk("hubs/getHubAuthCode", async (args: GetHubArgs) => {
  const { hubId } = args;
  const url = `${JANZU_URL}reef-api/hubs/${hubId}/auth-code`;
  const response = await fetch(url, { method: "POST" });
  if (response.ok) {
    const data = await response.json();
    return data.code as string;
  }
  throw new Error(`Failed to get auth code for Vision Core: ${hubId}`);
});

export const getHub = createAsyncThunk("hubs/getHub", async (args: GetHubArgs) => {
  const { hubId } = args;
  const HUBS_URL = `${JANZU_URL}reef-api/hubs/${hubId}`;
  const response = await fetch(HUBS_URL, {
    cache: CachePolicies.NO_CACHE,
  });
  if (response.ok) {
    const data = await response.json();
    const { all_online: allOnline, main_app_online: mainAppOnline } = data.status_detail;

    return {
      ...data,
      isLoading: false,
      isRestarting: isHubRestarting(hubId, allOnline, mainAppOnline),
      error: false,
    };
  }
  throw new Error(`Failed to fetch Vision Core details for id: ${hubId}`);
});
